{
  "settings": {
    "title": "Nastavenia používateľa",
    "profileTitle": "Profil",
    "profileSettings": "Nastavenia profilu",
    "memberSince": "Člen od {{date}}",
    "profile": {
      "title": "Profil",
      "email": "Email",
      "firstName": "Meno",
      "lastName": "Priezvisko",
      "save": "Uložiť zmeny"
    },
    "personalInfo": {
      "title": "Osobné údaje"
    },
    "bodyMetrics": {
      "title": "Telesné údaje",
      "weight": "Váha",
      "weightUnit": "kg",
      "height": "Výška",
      "heightUnit": "cm",
      "calorieGoal": "Denný cieľ kalórií",
      "calorieGoalUnit": "kcal",
      "gender": "Pohlavie",
      "sourceAppleHealth": "Apple Health",
      "sourceHealthConnect": "Health Connect",
      "sourceManual": "Ručne",
      "bodyFat": "Telesný tuk",
      "muscle": "Svaly",
      "bmi": "BMI",
      "latestComposition": "Aktuálne zloženie",
      "viewTrend": "Zobraziť vývoj zloženia tela",
      "notAvailable": "N/A"
    },
    "integrations": {
      "title": "Prepojené údaje",
      "appleHealth": "Apple Health",
      "healthConnect": "Health Connect",
      "description": "Tep, kalórie a telesné údaje",
      "caption": "Funguje s Apple Watch, Garminom a inteligentnými váhami.",
      "connect": "Prepojiť",
      "connecting": "Prepájanie…",
      "connected": "Prepojené",
      "partiallyConnected": "Čiastočne prepojené",
      "manage": "Spravovať"
    },
    "gender": {
      "MALE": "Muž",
      "FEMALE": "Žena",
      "OTHER": "Iné",
      "PREFER_NOT_TO_SAY": "N/A"
    },
    "fitnessGoal": {
      "title": "Fitness cieľ",
      "GAIN_WEIGHT": "Nabrať hmotnosť",
      "LOSE_WEIGHT": "Schudnúť",
      "STAY_FIT": "Udržať sa fit"
    },
    "activityLevel": {
      "title": "Úroveň aktivity",
      "NOT_ACTIVE": "Neaktívny",
      "NOT_ACTIVE_DESC": "Málo alebo žiadne cvičenie",
      "LIGHTLY_ACTIVE": "Mierne aktívny",
      "LIGHTLY_ACTIVE_DESC": "Cvičenie 1-3 dni/týždeň",
      "ACTIVE": "Aktívny",
      "ACTIVE_DESC": "Cvičenie 4-5 dní/týždeň",
      "VERY_ACTIVE": "Veľmi aktívny",
      "VERY_ACTIVE_DESC": "Cvičenie 6-7 dní/týždeň"
    },
    "dangerZone": {
      "title": "Nebezpečná zóna",
      "deleteAccount": "Zmazať účet",
      "deleteDescription": "Natrvalo zmazať váš účet a všetky dáta",
      "delete": "Zmazať",
      "confirmDelete": "Ste si istý?",
      "deleteWarning": "Táto akcia sa nedá vrátiť späť. Všetky vaše dáta budú natrvalo vymazané.",
      "confirmButton": "Áno, vymazať",
      "cancelButton": "Zrušiť",
      "subscriptionActiveTitle": "Najprv zrušte predplatné",
      "subscriptionActiveDescription": "Máte aktívne predplatné, ktoré sa obnoví. Pred zmazaním účtu ho zrušte v obchode, inak vám budú naďalej účtované platby.",
      "manageSubscription": "Spravovať predplatné"
    },
    "validation": {
      "firstNameRequired": "Meno je povinné",
      "lastNameRequired": "Priezvisko je povinné"
    }
  },
  "bodyComposition": {
    "title": "Zloženie tela",
    "subtitle": "Sledujte zloženie tela v čase",
    "currentWeight": "Aktuálna hmotnosť",
    "weight": "Hmotnosť",
    "bodyFat": "Telesný tuk",
    "muscle": "Svaly",
    "bmi": "BMI",
    "week": "Týždeň",
    "month": "Mesiac",
    "year": "Rok",
    "sync": "Synchronizovať",
    "emptyTitle": "Zatiaľ žiadne merania",
    "emptyBody": "Pripojte Apple Health alebo zadajte hmotnosť a začnite sledovať zloženie tela v čase.",
    "connect": "Pripojiť Apple Health",
    "errorTitle": "Merania sa nepodarilo načítať",
    "errorBody": "Skontrolujte pripojenie a skúste to znova.",
    "retry": "Skúsiť znova",
    "bmiHint": "Vyplňte hmotnosť a výšku vo svojom profile.",
    "addWeight": "Zadať hmotnosť",
    "logWeightTitle": "Zadajte hmotnosť",
    "logWeightSubtitle": "Pridajte ručný záznam do histórie zloženia tela.",
    "logWeightSave": "Uložiť"
  }
}
